










import { computed, defineComponent, PropType } from '@vue/composition-api';
import dayjs from 'dayjs';
import { getServerTime } from '@/utils/date-helper';
import { useCountdown } from '@/hooks/use-countdown';
import { TaskItem, TaskStatus } from '@/types/task';
import { i18n } from '@/i18n';

export default defineComponent({
  name: 'TaskBadage',
  props: {
    /** 任务日期信息 */
    taskInfo: {
      type: Object as PropType<TaskItem>,
      required: true,
    },
  },
  setup(props) {
    const { endTime } = props.taskInfo;
    const { countdownText, isCountdownEnd } = useCountdown(getServerTime(), endTime);
    /** 左上角任务时效信息 */
    const badageTips = computed(() => {
      const { startTime, endTime, status } = props.taskInfo;
      const currenDate = getServerTime();
      if (status === TaskStatus.notStart) { // 未开始
        const month = Number(dayjs(startTime).format('M'));
        const day = Number(dayjs(startTime).format('DD'));
        return {
          tips: i18n('{{month}}月{{day}}日開始', { month, day }),
          isDisabled: false,
        };
      }
      if (status === TaskStatus.soldOut) { // 针对限额任务，印花已派完
        return {
          tips: i18n('已派完'),
          isDisabled: true,
        };
      }
      if (status === TaskStatus.outdate || isCountdownEnd.value) { // 已结束
        return {
          tips: i18n('已結束'),
          isDisabled: true,
        };
      }
      let tips = '';
      const isBeforeEndOneDay = dayjs(currenDate) < dayjs(endTime).subtract(1, 'day');
      if (isBeforeEndOneDay) { // 剩余 > 1天
        const count = dayjs(endTime).diff(currenDate, 'day');
        const params = { count };
        tips = i18n('剩餘{{count}}天', params);
      } else { // 剩余 < 1天
        const countdown = countdownText.value.seconds.split(':').slice(1)
          .join(':');
        tips = i18n('限時 {{countdown}}', { countdown });
      };
      return {
        tips,
        isDisabled: false,
      };
    });
    const isLimitTask = computed(() => props.taskInfo.type === 'limit');
    return {
      badageTips,
      isLimitTask,
    };
  },
});
